import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Card } from '../../../components/Card';
import { HBox } from '../../../components/Box';
import { IsOpen } from '../../../components/Icon';
import { Cell, List, Row } from '../../../components/List';
import { getDate } from '../helpers';
import cn from 'classnames';
import styles from './ConsumptionEnviromentData.module.css';
import {
  DEP_FINANCE,
  DEP_COMMERCE,
  DEP_WALSTREET,
  DEP_ADMINISTRATION,
  DEP_IT,
  DEP_WORKSHOP,
  DEP_ADMIN,
  DEP_TRANSPORT,
} from '../../../components/Permission/constants';
import { Permission } from '../../../components/Permission';
import env from '../../../env';
import { AppClientId } from '../../Shared/constants';

const Container = styled.div`
  font-size: 14px;
  width: 100%;
  .cell:first-child {
    text-transform: capitalize;
  }

  .list-title {
    padding: 8px 0;
  }
  .info-card {
    min-width: 260px;
    width: 100%;
  }
`;

const STATE = {
  isOpen: env.clientId == AppClientId.AUTOWIENTJES ? true : false,
};

/* eslint-disable react/prefer-stateless-function */
class VehicleDataConsumptionComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {}

  render() {
    const vehicle = this.props.vehicle;
    return (
      <Container>
        <Card className={cn('vehicle-info-card info-card data', styles.card)}>
          <HBox>
            <h2 className="card-title mb-2 text-muted">{this.lbl('vehicle.info.data.consumption_and_enviroment')}</h2>

            <div onClick={() => this.setState({ isOpen: !this.state.isOpen })}>
              <IsOpen />
            </div>
          </HBox>
          {this.state.isOpen && (
            <List>
              {[
                'energy_label',
                'euro_class',
                'co2_rdw',
                'average_consumption_combined',
                'consumption_KwH',
                'max_chargingspeed_DC',
              ].map(property => {
                if (vehicle[property] && property === 'max_chargingspeed_DC') {
                  return (
                    <Row key={property}>
                      <Cell>{this.lbl(`vehicle.property.${property}`)}</Cell>
                      <Cell className="text-nowrap">{vehicle[property]} KW/h</Cell>
                    </Row>
                  );
                }
                if (vehicle[property] && property === 'average_consumption_combined') {
                  return (
                    <Row key={property}>
                      <Cell>{this.lbl(`vehicle.property.${property}`)}</Cell>
                      <Cell>{vehicle[property] / 100}/100</Cell>
                    </Row>
                  );
                }
                return (
                  vehicle[property] && (
                    <Row key={property}>
                      <Cell>{this.lbl(`vehicle.property.${property}`)}</Cell>
                      <Cell className="text-nowrap">{vehicle[property]}</Cell>
                    </Row>
                  )
                );
              })}

              <h2 className="list-title text-muted">{this.lbl('vehicle.info.data.vehicle_info')}</h2>
              {['number_of_seats', 'interior_color', 'interior_type', 'number_of_doors'].map(property => {
                return (
                  vehicle[property] && (
                    <Row key={property}>
                      <Cell>{this.lbl(`vehicle.property.${property}`)}</Cell>
                      <Cell className="text-nowrap">{vehicle[property]}</Cell>
                    </Row>
                  )
                );
              })}
              <h2 className="list-title text-muted">{this.lbl('vehicle.info.data.dimensions_and_mass')}</h2>
              {[
                'loadingspace',
                'tanks_capacity',
                'max_allowed_weight',
                'rDWMassaRijklaar',
                'empty_weight',
                'trackwidth',
                'rDWMaximumMassa',
                'trailer_with_brakes',
                'trailer_without_brakes',
              ].map(property => {
                const unit = ['trackwidth'].includes(property) ? 'Cm' : 'Kg';

                if (
                  vehicle[property] &&
                  [
                    'max_allowed_weight',
                    'rDWMassaRijklaar',
                    'empty_weight',
                    'rDWMaximumMassa',
                    'trailer_with_brakes',
                    'trailer_without_brakes',
                    'trackwidth'
                  ].includes(property)
                ) {
                  return (
                    <Row key={property}>
                      <Cell>{this.lbl(`vehicle.property.${property}`)}</Cell>
                      <Cell className="text-nowrap">{vehicle[property]} {unit}</Cell>
                    </Row>
                  );
                }
              })}

              <h2 className="list-title text-muted">{this.lbl('vehicle.info.data.finance_and_taxes')}</h2>
              {['taxadditions_percentage', 'taxaddion_until'].map(property => {
                if (vehicle[property] && property === 'taxadditions_percentage') {
                  return (
                    <Row key={property}>
                      <Cell>{this.lbl(`vehicle.property.${property}`)}</Cell>
                      <Cell className="text-nowrap">{vehicle[property]} %</Cell>
                    </Row>
                  );
                }
                return (
                  vehicle[property] && (
                    <Row key={property}>
                      <Cell>{this.lbl(`vehicle.property.${property}`)}</Cell>
                      <Cell className="text-nowrap">{getDate(vehicle[property])}</Cell>
                    </Row>
                  )
                );
              })}

              {vehicle['number_of_axles'] && (
                <>
                  <h2 className="list-title text-muted">{this.lbl('vehicle.info.data.technical')}</h2>
                  {['number_of_axles'].map(property => {
                    return (
                      vehicle[property] && (
                        <Row key={property}>
                          <Cell>{this.lbl(`vehicle.property.${property}`)}</Cell>
                          <Cell className="text-nowrap">{vehicle[property]}</Cell>
                        </Row>
                      )
                    );
                  })}
                </>
              )}
            </List>
          )}
        </Card>
      </Container>
    );
  }
}

VehicleDataConsumptionComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const VehicleDataConsumptionCard = compose(withConnect, withRouter)(VehicleDataConsumptionComp);
